import { render, staticRenderFns } from "./draft-24.vue?vue&type=template&id=702f6558&scoped=true"
import script from "./draft-24.vue?vue&type=script&lang=js"
export * from "./draft-24.vue?vue&type=script&lang=js"
import style0 from "./draft-24.vue?vue&type=style&index=0&id=702f6558&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702f6558",
  null
  
)

export default component.exports